import { render, staticRenderFns } from "./ViewOrderModal.vue?vue&type=template&id=c2ade13e&scoped=true&"
import script from "./ViewOrderModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderModal.vue?vue&type=style&index=0&id=c2ade13e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ade13e",
  null
  
)

export default component.exports